/**
 * Created by hejiahui on 2018/5/5.
 */

/*
* lrz upload images to tecent cloud server
* **/
// 引入 tecent SDK
// import CosCloud from "@/assets/js/cos-js-sdk-v4.js"
// import CosCloud from 'cos-js-sdk-v5'
// // api
// import { fetchGet, picAPI } from '@/assets/api/index.js';
// // mint-ui
// import { Indicator, Toast } from 'mint-ui';

/* eslint-disable */
import EXIF from 'exif-js'
// import VConsole from "vconsole/dist/vconsole.min.js";
// import store from '@/store'
export default {
  data() {
    return {
      imagesFiles: [], // e.target.files
      previewImages: [], // window.uril.createOBjUrl
      submitImages: [],
      // 腾讯云上传实例
      cosInstance: null,
      showInput: true, //解决input只能点击一次
      isFixedIos10: false,
      testImg: null
    }
  },
  mounted() {
    // let vConsole = new VConsole() // 线上测试用
    // console.log(!HTMLCanvasElement.prototype.toBlob,'toBlob')
    this.isFixedIos10 = !HTMLCanvasElement.prototype.toBlob, 'toBlob'
    this.initCos()
    // Indicator.open({
    //  text: '加载中...',
    //  spinnerType: 'double-bounce'
    // });
    // setTimeout(()=>{
    //  Indicator.close()
    // },1000)

    // if(!this.isNeedPreview){
    // console.log('isNeedPreview')
    this.$watch('previewImages', (newVal) => {
      // console.log('watch', newVal, this.previewImages)
      this.$emit('update:previewImages', this.previewImages)
    })
    // }
    if (this.maxLength > 1) {
      this.$refs.fileinput.setAttribute('multiple', 'multiple')
    }
  },
  methods: {
    // 获取cos签名与cos对象
    initCos() {
      // this.cosInstance = new CosCloud({
      //   getAuthorization: function (options, callback) {
      //     fetchGet(picAPI,
      //       {},
      //       null).then(res => {
      //       const tempKeys = res.data.tempKeys
      //       callback({
      //         TmpSecretId: tempKeys.credentials && tempKeys.credentials.tmpSecretId,
      //         TmpSecretKey: tempKeys.credentials && tempKeys.credentials.tmpSecretKey,
      //         XCosSecurityToken: tempKeys.credentials && tempKeys.credentials.sessionToken,
      //         ExpiredTime: tempKeys.expiredTime
      //       })
      //     })
      //   }
      // })
    },
    // outPutImages () {
    //   const self = this
    //   return new Promise((resolve, reject) => {
    //     (async () => {
    //       var image = []
    //       if (self.maxLength == 1) {
    //         const img = this.imagesFiles[0]
    //         const sName = img.sName
    //         const bName = img.bName
    //         let sNewUrl = await this.uploadToCloud(img.smallBlob, sName, 0)
    //         let bNewUrl = await this.uploadToCloud(img.bigBlob, bName, 0)
    //         this.imagesFiles = [] // e.target.files
    //         this.previewImages = []
    //         resolve({
    //           small: 'http://' + sNewUrl,
    //           big: 'http://' + bNewUrl
    //         })
    //       } else {
    //         for (let i = 0; i < this.imagesFiles.length; i++) {
    //           let img = this.imagesFiles[i]
    //           let index = i
    //           const sName = img.sName
    //           const bName = img.bName
    //           let sNewUrl = await this.uploadToCloud(img.smallBlob, sName, index)
    //           let bNewUrl = await this.uploadToCloud(img.bigBlob, bName, index)
    //           image.push({
    //             small: 'http://' + sNewUrl,
    //             big: 'http://' + bNewUrl
    //           })
    //         }
    //         this.imagesFiles = [] // e.target.files
    //         this.previewImages = []
    //         resolve(image)
    //       }
    //     })()
    //   })
    // },
    // 上传到阿里云
    uploadToAli(val) {
      return new Promise((resolve, reject) => {
        let url = '/consult/upload'
        let formFile = new FormData()
        // console.log(val,'要上传的参数')
        // const targetFile = this.$refs.imageUpload.imagesFiles[0].bigBlob
        // console.log(this.imagesFiles, 'imagesFiles')
        // const targetFile = this.imagesFiles[0].bigBlob
        // const targetFile = this.imageUpload.imagesFiles[0].bigBlob
        // console.log(targetFile, 'upload')
        // const targetFile = upload.imagesFiles[0].smallBlob
        formFile.append('file', val)
        // console.log(formFile, 'formFile')
        this.$http
          .post(url, formFile, {
            headers: { 'Content-Type': 'multipart/form-data' }
          })
          .then(res => {
            // console.log(res, 'ressss')
            if (res.data.error === 0) {
              this.$toast.clear()
              let imgUrl = res.data.data.xdurl
              this.resultUrl = imgUrl
              this.$store.dispatch('setImgUrl', imgUrl)
              // console.log(imgUrl)
            } else {
              this.$toast('图片太大，上传失败~')
            }
          })
      })
    },
    uploadToCloud(blob, name, index) {
      var chinese = ['一', '二', '三', '四']
      const self = this
      return new Promise((resolve, reject) => {
        const Region = 'ap-guangzhou', Bucket = 'ccnf-im-1255573444'
        // 分片上传文件
        this.cosInstance.sliceUploadFile({
          Bucket: Bucket,
          Region: Region,
          Key: name,
          Body: blob,
          onHashProgress: function (progressData) {
            console.log('校验中', JSON.stringify(progressData))
          },
          onProgress: function (progressData) {
            console.log('上传中', JSON.stringify(progressData))
            const percent = progressData.percent
            if (percent == 1) {
              // Indicator.close()
            } else {
              // Indicator.open({
              //   text: `正在上传第${chinese[index]}张 ${parseInt(percent * 100)}%`,
              //   spinnerType: 'double-bounce'
              // })
            }
          }
        }, function (err, data) {
          // Indicator.close()
          console.log(err, data)
          if (typeof data === 'object' && 'Location' in data) {
            resolve(data.Location)
          }
        })
      })
    },
    selectImages(e) {
      const files = e.target.files
      if (files.length > 0) {
        this.$toast({
          message: '图片上传中，请稍候~',
          duration: 3000,
          forbidClick: true, // 禁用背景点击
          mask: true,
        })
        console.log(files[0].size + ' b = ' + files[0].size / 1024 / 1024 + " M", '原图大小')
        const isPass = this.imageFilter(files)
        if (isPass == false) {
          return false
        }
        // 存放 files 数组
        const filesArray = Array.prototype.map.call(files, (file) => file)
        // console.log(filesArray,'filesArray')
        if (filesArray[0].size > 10 * 1000 * 1000) {
          this.$toast('文件太大,请从新选择')
          this.$refs.fileinput.value = ''
        } else {
          this.mapImages(filesArray)
        }
        // console.log(this.showInput,'upload')
        // console.log(this.$refs.fileinput.value,'this.$refs.fileinput.value')
      }
    },
    // 取消某一张的上传
    giveUpANIamge(index) {
      this.previewImages.splice(index, 1)
      this.imagesFiles.splice(index, 1)
    },
    // 上传后的图片预览展示
    previewImage(files) {
      const FILES = files
      // e.target.files 不是数组 不能用map，只能用for 直接便利
      return this.previewImages.concat(Array.prototype.map.call(FILES, (image, key) => {
        let url = this.getObjectURL(image)
        console.log(`>>>第 ${key} 张图：${url} `)
        const img = new Image()
        img.onload = () => {
          this.revokeObjectURL(url)
        }
        return url
      }))
    },
    // 释放内存中指定的文件对象
    revokeObjectURL(file) {
      window.URL.revokeObjectURL(objectURL)
    },
    // 获取 url 在内存的片段url
    getObjectURL(file) {
      let url = null
      // URL.createObjectURL() 静态方法会创建一个 DOMString，其中包含一个表示参数中给出的对象的URL
      if (window.createObjectURL != undefined) { // basic
        url = window.createObjectURL(file)
      } else if (window.URL != undefined) { // mozilla(firefox)
        url = window.URL.createObjectURL(file)
      } else if (window.webkitURL) { // webkit or chrome
        url = window.webkitURL.createObjectURL(file)
      }
      return url
    },
    imageFilter(files) {
      // 是否符合的图片格式和大小
      let isMatch = true
      const chinese = ['一', '二', '三', '四']
      // if (files.length > this.maxLength || (files.length + this.imagesFiles.length) > this.maxLength) {
      //   console.log(`最多只能上传${this.maxLength}张图片`, 2000)
      //   return false
      // }
      for (var i = 0, file; file = files[i]; i++) {
        // console.log(file)
        // console.log(file.type)
        if (file.type.indexOf('image') == 0) {
          if (file.size >= this.maxSize * 1024 * 1024) { // 2MB
            // console.log('您上传的第' + chinese[i] + '张图片大小过大，应小于5M，请重新上传', 3000)
            this.$toast(`您上传的第${chinese[i]}张图片大小过大，应小于5M，请重新上传`)
            isMatch = false
          }
        } else {
          console.log('文件"' + file.name + '"不是图片。请重新上传', 2000)
          this.$toast(`文件${file.name}不是图片。请重新上传`)
          isMatch = false
        }
      }
      return isMatch
    },
    mapImages(files) {
      const self = this
      var image = []
      var len = files.length
      var flag = 0
      async function mapIt(flag) {
        if (flag == len) {
          return
        }
        const file = files[flag]
        const imageType = file.name.split('.')[1]
        const sName = file.lastModified + '-small-' + parseInt(Math.random() * 10000) + '.' + imageType
        const bName = file.lastModified + '-big-' + parseInt(Math.random() * 10000) + '.' + imageType
        // console.log(name)
        // console.log(file.name,'filename')
        // console.log(file.type.indexOf('image') == 0,'flag')
        if (file.type.indexOf('image') == 0) {
          // console.log(files, 'files')
          // let flag = 'noZip'
          if (flag == 'noZip') {
            console.log('我不压缩')
            self.uploadToAli(files[0])
          } else {
            console.log('我要压缩')
            var result = await self.imgReady(file)
            console.log(result, 'result')
            self.imagesFiles.push({
              bigBlob: result.bigPic,
              smallBlob: result.smallPic,
              sName: sName,
              bName: bName
            })
            // console.log('debug-----------------------------------', self.imagesFiles[0])
            // 上传压缩后的图 smallBlob
            self.uploadToAli(self.imagesFiles[0].smallBlob).then(self.imagesFiles.pop())
            // console.log(self.imagesFiles, 'imagesFiles')
            if (flag == len - 1) {

              if (self.$refs && self.$refs.fileinput) {
                // self.$refs.fileinput.value = ''
              }
            } else {
              flag += 1
              mapIt(flag)
            }
          }
        }
      }
      mapIt(flag)
    },
    convertBase64UrlToFile(urlData) {
      // console.log('我进来了')
      var arr = urlData.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        fileExt = mime.split('/')[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], 'fileName.' + fileExt, { type: mime })
    },
    dataURLtoBlob(dataUrl) {
      if (!HTMLCanvasElement.prototype.toBlob) {
        canvas.toBlob(function (blob) {
          fd.append('pic', blob)
        }, file.type || 'image/png');
      }
      var mimeString = dataUrl.split(',')[0].split(':')[1].split(';')[0] // mime类型
      var byteString = atob(dataUrl.split(',')[1]) // base64 解码
      var arrayBuffer = new ArrayBuffer(byteString.length) // 创建缓冲数组
      var intArray = new Uint8Array(arrayBuffer) // 创建视图
      for (let i = 0; i < byteString.length; i += 1) {
        intArray[i] = byteString.charCodeAt(i)
      }
      var blob = new Blob([intArray], { type: mimeString }) // 转成blob
      return blob
    },
    rotateImg(img, direction, canvas, fileType, compressRate = 600) {
      let min_step = 0
      let max_step = 3
      if (img == null) return
      // img的高度和宽度不能在img元素隐藏后获取，否则会出错
      let height = img.height
      let width = img.width
      // console.log(height, '图片的高度')

      // ！！！！！压缩方法！！！！！分辨比率压缩！！！！！
      if (width > compressRate || height > compressRate * 2) {
        let picRate = parseInt(width / compressRate)
        width /= picRate
        height /= picRate
        // console.log('分辨比率压缩', 'picRate:', picRate, 'width', width, 'height', height)
      }
      /* if(width > height ){
        width = height
      }
      if( height > width ){
        height = width
      } */
      let step = 2
      if (step == null) {
        step = min_step
      }
      if (direction == 'right') {
        step++
        // 旋转到原位置，即超过最大值
        step > max_step && (step = min_step)
      } else if (direction == '') {
        step = 0
      } else if (direction == 'bottomRight') {
        step = 2
      } else {
        step--
        step < min_step && (step = max_step)
      }
      let degree = step * 90 * Math.PI / 180
      let ctx = canvas.getContext('2d')
      switch (step) {
        case 0:
          canvas.width = width
          canvas.height = height
          ctx.drawImage(img, 0, 0, width, height)
          break
        case 1:
          canvas.width = height
          canvas.height = width
          ctx.rotate(degree)
          ctx.drawImage(img, 0, -height, width, height)
          break
        case 2:
          canvas.width = width
          canvas.height = height
          ctx.rotate(degree)
          ctx.drawImage(img, -width, -height, width, height)
          break
        case 3:
          canvas.width = height
          canvas.height = width
          ctx.rotate(degree)
          ctx.drawImage(img, -width, 0, width, height)
          break
      }
      // if(this.isFixedIos10) {
      //   return canvas
      // }
      // this.uploadToAli()
      let fdata = canvas.toDataURL(fileType, 1)
      // console.log("压缩后大小", fdata.length / 1024 + "Kb");
      return fdata;
    },
    uploadBlbob(val) {
      let url = '/consult/uploadBlob'
      // let params = {
      //   blob: val,
      //   extension: 'png'
      // }
      // console.log(val, 'val')
      let formFile = new FormData()
      formFile.append('blob', val)
      // this.$http.post(url,this.$ObjToFd(params)).then(res=>{
      this.$http.post(url, formFile).then(res => {
        // console.log(res, 'res blob')
        if (res.data.error == 0) {
          let imgUrl = res.data.data
          this.resultUrl = imgUrl
          // console.log(imgUrl, 'imgUrl')
          this.$store.dispatch('setImgUrl', imgUrl)
        }
      })
      // console.log(val, 'blobbbbbb')
    },
    imgReady(obj) {
      let self = this
      let reader = new FileReader()
      reader.readAsDataURL(obj)
      return new Promise((resolve, reject) => {
        reader.onload = function (f) {
          let res = this.result
          let img = new Image()
          img.onload = async () => {
            let compressedData = await self.compress2(img, obj.type)
            // console.log(compressedData,'compressedData')
            self.testImg = compressedData.bigPic
            let bigFile = self.convertBase64UrlToFile(compressedData.bigPic)
            let smallFile = self.convertBase64UrlToFile(compressedData.smallPic)
            // let bigFile = self.dataURLtoBlob(compressedData.bigPic)
            // let smallBlob = self.dataURLtoBlob(compressedData.smallPic)
            // self.uploadBlbob(smallFile)
            console.log('bigFile=====', bigFile, 'smallFile======', smallFile, 'imgReady')
            self.previewImages.push(compressedData.smallPic)
            resolve({ bigPic: bigFile, smallPic: smallFile })
            // self.uploadToAli(bigFile)
            img = null
          }
          img.src = res
        }
      }).catch((e) => {
        console.log(e)
      })
    },
    compress2(img, fileType) {
      let canvas = document.createElement('canvas')
      let rotateshow, smallshow
      const rotateImg = this.rotateImg

      return new Promise((resolve, reject) => {
        // 判断照片 横竖屏
        EXIF.getData(img, () => {
          EXIF.getAllTags(img)
          let Orientation = EXIF.getTag(img, 'Orientation')
          console.log(Orientation, "direction")
          switch (Orientation) {
            case 6:
              rotateshow = rotateImg(img, 'left', canvas, fileType)
              smallshow = rotateImg(img, 'left', canvas, fileType, 250)
              break
            case 8:
              rotateshow = rotateImg(img, 'right', canvas, fileType)
              smallshow = rotateImg(img, 'right', canvas, fileType, 250)
              break
            case 3:
              rotateImg(img, 'bottomRight', canvas, fileType)
              rotateshow = rotateImg(img, 'bottomRight', canvas, fileType)
              smallshow = rotateImg(img, 'bottomRight', canvas, fileType, 250)
              break
            default:
              rotateshow = rotateImg(img, '', canvas, fileType)// img.src;
              smallshow = rotateImg(img, '', canvas, fileType, 250)
          }
          resolve({ bigPic: rotateshow, smallPic: smallshow })
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/upload.js